import React from 'react'
import { Divider, Row, Form, Button, Input, Switch, notification } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import { Link } from 'react-router-dom'

const INIT = {
    name: '',
    percent_value: '',
    active: true,
}

const CustomerTypesCreateContainer = () => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)

    const disabled = !data.name || !data.percent_value

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const handleSubmit = e => {
        setloading(true)
        e.preventDefault()

        API.post('/api/customer_types', data)
            .then(() => {
                setloading(false)
                setData(INIT)

                notification.success({
                    message: 'El tipo de precio se ha creado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Crear tipo de precio</Divider>
            <Form style={{ maxWidth: '400px', margin: 'auto' }}>
                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser
                    llenados.
                </p>
                <Form.Item label="Nombre" className="required" hasFeedback>
                    <Input
                        placeholder="Nombre"
                        value={data.name}
                        onChange={e => {
                            handleChange('name', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Porcentaje" className="required" hasFeedback>
                    <Input
                        placeholder="Porcentaje"
                        value={data.percent_value}
                        onChange={e => {
                            handleChange('percent_value', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Activo" hasFeedback>
                    <Switch
                        checked={!!data.active}
                        onChange={value => {
                            handleChange('active', value)
                        }}
                    />
                </Form.Item>


                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/customer_types">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>





            </Form>
        </Segment>
    )
}

export default CustomerTypesCreateContainer
